import { FieldError } from "./field-error";

export class StepError {
    public errors: FieldError[];
    public isCheckValid: boolean;
}
